import { Component, Input, OnInit } from '@angular/core';
import { FieldConfig } from 'projects/borrower-app/src/app/models/wizard/config/field-config-model';
import { LocalizedEditService } from 'projects/borrower-app/src/app/transloco/localized-edit.service';

@Component({
    selector: 'field-config-editor',
    templateUrl: 'field-config-editor.component.html',
    styleUrls: ['field-config-editor.component.scss'],
    standalone: false
})

export class FieldConfigEditorComponent implements OnInit {

  @Input()
  fieldConfigs: FieldConfig[] = [];

  @Input()
  header: string = "Field Configuration";

  constructor(public readonly i18n: LocalizedEditService) { }

  ngOnInit() { }
}
